<template>
  <div class="card">
    <p class="body-2">
      {{ blok.text }}
    </p>
    <NuxtLink
      :to="`/${locale}/${$t('vacancies.code')}`"
      class="body-3"
      @click="back"
    >
      {{ $t('vacancies.back') }}
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
  import { useFilterStore } from '~/stores'

  defineProps<{
    blok: { text: string }
  }>()

  const { locale } = useI18n()
  const filtersStore = useFilterStore()

  const back = () => {
    filtersStore.$reset()
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .card {
    margin: auto;
    max-width: 445px;
    padding: 32px;
    text-align: center;

    :deep(a) {
      font-weight: 600;
      text-decoration: underline;
    }
  }
</style>
